import React, { useEffect, useState } from 'react'
import { db } from '../../../firebase';
import Mapinfo from './Mapinfo';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';


function Branchinfo({branchId}) {
  const [post, setPost] = useState()
  useEffect(() => {
    db.collection('branches').doc(`${branchId}`).onSnapshot((doc) => {
      setPost(doc.data());
    });
}, [])
  return (
    <div>
                          <div id="restaurant-info" className="bg-white rounded shadow-sm p-4 mb-4">

                    <h5 className="mb-4">Branch Info</h5>
                    <p className="mb-3">{post?.branchAddress},
                      <br /> {post?.branchPlot}
                      <br/> {post?.branchFloor}
                    </p>
                    <p className="mb-2 text-black"><i className="icofont-phone-circle text-primary mr-2" /><a href={`tel: ${post?.branchPhone}`}>{post?.branchPhone}</a></p>
                    <p className="mb-2 text-black"><i className="icofont-email text-primary mr-2" /> <a href={`mailto: ${post?.branchEmail}`} className="__cf_email__" data-cfemail="224b434f4d51434a434c62454f434b4e0c414d4f">{post?.branchEmail}</a></p>
                    <p className="mb-2 text-black"><i className="icofont-clock-time text-primary mr-2" /> {post?.openingTime} – {post?.closingTime}
                      {/* <span className="badge badge-success"> OPEN NOW </span> */}
                    </p>
                    <hr className="clearfix" />
                    <h5 className="mt-4 mb-4">More Info</h5>
                    <div className="border-btn-main mb-4">

                    <Paper sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableBody>
          <TableRow>
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Restaurant</span> 
              </TableCell>
              <TableCell >
              {!post?.restaurant ?(
                        <>N/A</>
                    ):(
                        <>
                        {post?.restaurant}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          <TableRow>              
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Manager</span> 
              </TableCell>
              <TableCell >
                    {!post?.managerFullName ?(
                        <>N/A</>
                    ):(
                        <>
                        {post?.managerFullName}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          <TableRow>              
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Creator Name</span> 
              </TableCell>
              <TableCell >
                    {!post?.createdByName ?(
                        <>N/A</>
                    ):(
                        <>
                        {post?.createdByName}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          <TableRow>
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Creator Email</span> 
              </TableCell>
              <TableCell >
                    {!post?.createdByEmail ?(
                        <>N/A</>
                    ):(
                        <>
                        {post?.createdByEmail}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          <TableRow>
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Creator Email</span> 
              </TableCell>
              <TableCell >
                   2022
              </TableCell>
          </TableRow>

          </TableBody>
        </Table>
      </TableContainer>

    </Paper>
                    </div>

                  </div>
    </div>
  )
}

export default Branchinfo